import React from 'react'

import { Card } from '@/shared/components/ui/card'
import { cn } from '@/shared/lib/utils'

export default function Widget({
	children,
	className,
	...props
}: {
	children: React.ReactNode
	className?: string
} & React.HTMLAttributes<HTMLDivElement>) {
	return (
		<Card className={cn(className)} {...props}>
			{children}
		</Card>
	)
}
